export default "__VITE_ASSET__DtZ$Kf$f__"